import deepFreeze from 'deep-freeze-strict';
import { assign, isEmpty, isFunction, isObject } from 'lodash';

export default {
    create,

    is(object: object, type: Function) {
        return isObject(object) && object instanceof type;
    },

    check(object: object, type: Function) {
        if (!this.is(object, type)) {
            throw new TypeError("Expected instance of '" + type.name + "'.");
        }
    },

    checkType(type: Function) {
        if (!isFunction(type)) {
            throw new Error('Expected the type to be a function.');
        }

        if (isEmpty(type.name)) {
            throw new Error("Expected the type's name to be a non-empty string.");
        }
    },
};

function create<M1 extends {}>(type: Function, ...mixins: [M1]): M1;
function create<M1 extends {}, M2 extends {}>(type: Function, ...mixins: [M1, M2]): M1 & M2;
function create<M1 extends {}, M2 extends {}, M3 extends {}>(type: Function, ...mixins: [M1, M2, M3]): M1 & M2 & M3;
function create(type: Function, ...mixins: {}[]): {} {
    return deepFreeze(assign(Object.create(type.prototype), ...mixins));
}
